import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IonicModule } from '@ionic/angular';

import { HeaderModule } from '../../../shared/component/common/header/header.module';
import { ButtonModule } from '../../../shared/component/common/button/button.module';
import { LabelModule } from '../../../shared/component/common/label/label.module';
import { AddressCityComponent } from './address-city.component';
import { RadioModule } from '../../../shared/component/common/radio/radio.module';
import { SearchModule } from '../../../shared/component/common/search/search.module';
import { RetryModule } from '../../../shared/component/common/retry/retry.module';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    HeaderModule,
    ButtonModule,
    LabelModule,
    RadioModule,
    SearchModule,
    RetryModule,
  ],
  declarations: [AddressCityComponent]
})
export class AddressCityComponentModule {}
